import * as $ from "jquery";
import * as React from "react";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";

interface Props {
    children?: React.ReactNode;
}

export default class Layout extends React.Component<Props, {}> {

    public render() {
        return (
            <div className="app header-fixed aside-menu-fixed aside-menu-hidden">
                <Header />
                <div className="app-body" style={{ position: "relative" }}>
                    <Sidebar />
                    <main className="main">
                        {this.props.children}
                        <Footer />
                    </main>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        /* ---------- Disable moving to top ---------- */
        $('a[href="#"][data-top!=true]').click(function (e) {
            e.preventDefault();
        });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/Layout.tsx